import { createContext, use } from "react";
import type { CapacityCalendarController } from "./use-capacity-calendar";

/** Interface */
interface ICapacityCalendarContext {
	controller: CapacityCalendarController;
	getIsExpanded: (rowId: string) => boolean;
	toggleExpanded: (rowId: string) => void;
}

export const CapacityCalendarContext = createContext<ICapacityCalendarContext>(
	{} as ICapacityCalendarContext,
);

export function useCapacityCalendarContext() {
	return use(CapacityCalendarContext);
}
